import { useQuery } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { getMappedRecommendationData } from "mappers";
import { creditReviewDetailsService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

type useGetRecommendationQueryProps = {
	creditReviewId: string;
};

const useGetRecommendationQuery = ({
	creditReviewId,
}: useGetRecommendationQueryProps) => {
	const dispatch = useDispatch();

	const queryResult = useQuery(
		["executiveRecommendationInfo", creditReviewId],
		() =>
			creditReviewDetailsService.getRecommendationInfo({
				creditReviewId,
			}),
		{
			select: data => {
				return getMappedRecommendationData(data);
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
			enabled: !!creditReviewId,
			cacheTime: 0,
		},
	);

	return queryResult;
};

export default useGetRecommendationQuery;
